import { hostingActions } from "../actionCreators";

const initialState = {
    daemonsList: [],
    daemonDetails: {},
    foundDaemonInfo: {},
};

const hostingReducer = (state = initialState, action) => {
    switch (action.type) {
        case hostingActions.SET_DAEMONS_LIST: {
            return { ...state, daemonsList: action.payload };
        }
        case hostingActions.SET_DAEMON_DETAILS: {
            return { ...state, daemonDetails: action.payload };
        }
        case hostingActions.SET_FOUND_DAEMON_INFO: {
            return { ...state, foundDaemonInfo: action.payload };
        }
        default:
            return state;
    }
};

export default hostingReducer;
